// extracted by mini-css-extract-plugin
export var details = "_l9-0";
export var inspectorPopover = "_l9-1";